import {replaceMediaLikeTagsWithIds} from '@/common/questionPrintView/shared'

const buildDefaultQuestionPrintView = (content) => {
    if (content && content.question) {
        return replaceMediaLikeTagsWithIds(content.question)
    }

    if (content && content.question_prompt) {
        return replaceMediaLikeTagsWithIds(content.question_prompt)
    }

    return ''
}

export {buildDefaultQuestionPrintView}
